import { ref } from 'vue'

export function useAppModal() {
  const isModalOpen = ref<boolean>(false)
  const closeModal = () => (isModalOpen.value = false)
  const openModal = () => (isModalOpen.value = true)

  return { isModalOpen, closeModal, openModal }
}
